import { usePriority } from "@pbm/programs/hooks";
import { useMemo } from "react";
import { IProgram } from "@pbm/programs/contracts";
import { Column } from "react-table";
import { useParams } from "react-router-dom";
import { IntlDateTime } from "@funcional/react-intl-ui";
import { GridViewDropZone } from "../components/GridDropZone/GridViewDropZone.component";
import { DefaultColumnFilter } from "@funcional/react-table-ui";

export default function ListProgramPriority() {
  const { establishmentIdentity }: { establishmentIdentity: string } =
    useParams();

  usePriority({
    filter: {
      establishmentIdentity: establishmentIdentity,
    },
  });

  const columns: Column<IProgram>[] = useMemo(
    () => [
      {
        Header: "Prioridade",
        accessor: "priority",
        Filter: DefaultColumnFilter,
      },
      {
        Header: "Código",
        accessor: "code",
      },
      {
        Header: "Nome",
        accessor: "name",
      },
      {
        Header: "Início da vigência",
        accessor: "effectiveSince",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
      {
        Header: "Fim da vigência",
        accessor: "effectiveUntil",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
    ],
    []
  );

  return (
    <>
      <GridViewDropZone<IProgram> columns={columns} hook={usePriority} />
    </>
  );
}
